<template>
  <div class="desktop-version"  v-loading="loading">
    <div class="u-mt2 u-mb4">
      <span v-if="version"> <span class="u-text--light u-text--sm">Version on production site:</span> <el-tag>{{version}}</el-tag></span>
      <span v-if="!version && !loading">No build version found</span>
    </div>
    <ba-web-preview v-if="url" :url="url"></ba-web-preview>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import WebPreview from './web-preview.component'

  export default {
    name: 'ba-desktop-version',
    components: {
      'ba-web-preview': WebPreview
    },
    props: ['companyId'],
    data () {
      this.load_version()
      return {
        version: '',
        url: '',
        loading: true,
      }
    },
    methods: {
      async load_version () {
        let url = config.url + `/company/${this.companyId}/builds/version/desktop/`
        try {
          let response = await axios.get(url)
          this.version = response.data.version
          this.url = response.data.url
        } finally {
          this.loading = false
        }
      }
    },
  }
</script>
